<style scoped>
.task-item {
  display: flex;
  align-items: center;
  margin-left: 70px;
  margin-bottom: 20px;
}
.task-item .red {
  color: #f83c4a;
}
.task-item .el-form-item {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.task .el-dialog__body {
  padding-top: 20px;
}
.task .el-form-item__label {
  word-break: keep-all;
}
.task .el-upload__tip {
  line-height: 23px;
}
.task-file .el-form-item__label {
  align-self: flex-start;
}
</style >
<template>
  <div class="content task">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="7">
          <div class="search-area-div">业务员姓名：</div>
          <el-input v-model="searchPromotionParams.staffName" class="ipt-sty" placeholder="请输入业务员姓名"></el-input>
        </el-col>
        <el-col :span="7">
          <div class="search-area-div">所属公司：</div>
          <el-select v-model="searchPromotionParams.tenantGuid" placeholder="请选择所属公司" class="ipt-sty">
                 <el-option 
                    v-for="item in tenantList"
                    :key="item.sendTenantGuid"
                    :label="item.sendTenantName"
                    :value="item.sendTenantGuid">
                 </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button size="medium" type="info" :loading="exportSettingLoading" @click="getPromotionRecord"
              >搜索</el-button
            >
            <el-button size="medium" type="danger" :loading="exportSettingLoading" @click="clearDialogSearch(1)"
              >清空</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button size="medium" type="info" @click="exportPromotion" :loading="exportSettingLoading">导出记录</el-button>
    </div>

    <div class="back-color-fff p16">
      <el-table :data="promotionList" border style="width: 100%" :height="height" v-loading="exportSettingLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (searchPromotionParams.pageIndex - 1) * searchPromotionParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="业务员姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="organisationNames" label="所在部门" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.organisationNamesText }}</template>
        </el-table-column>
        <el-table-column prop="promoteNum" label="推广成功数" header-align="center" align="center"></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope"
            ><span @click="openCustomerDialog(scope.row)" style="color: #4fa1a4; cursor: pointer"
              >客户明细</span
            ></template
          >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        style="text-align: center"
        background
        @size-change="getPromotionRecord"
        @current-change="getPromotionRecord"
        :page-sizes="[10, 100, 200]"
        :current-page.sync="searchPromotionParams.pageIndex"
        :page-size.sync="searchPromotionParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="promotionTotalRows"
      >
      </el-pagination>
    </div>

    <!-- 客户明细 -->
    <el-dialog :title="currentStaff + '-推广记录'" :visible.sync="showCustomer" width="800px" center>
      <div class="search-area" style="padding-top: 0">
        <el-row :gutter="1">
          <el-col :span="10"
            >客户名称：
            <el-input
              v-model="searchCustomerParams.customerName"
              class="ipt-sty"
              placeholder="请输入客户名称搜索"
            ></el-input>
          </el-col>
          <el-col :span="14">
            <div style="dispaly: flex; align-items: center; text-align: right">
              <el-button size="small" type="info" @click="getCustomerDetailList">搜索</el-button>
              <el-button size="small" type="danger" @click="clearDialogSearch(2)">清空</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table :data="customerDetailList" border style="width: 100%" height="500px">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (searchCustomerParams.pageIndex - 1) * searchCustomerParams.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="customerName" label="客户名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="promoteTime" label="推广时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.promoteTime | getTimeDate }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        style="text-align: center"
        background
        @size-change="getCustomerDetailList"
        @current-change="getCustomerDetailList"
        :page-sizes="[10, 100, 200]"
        :current-page.sync="searchCustomerParams.pageIndex"
        :page-size.sync="searchCustomerParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="customerTotalRows"
      >
      </el-pagination>
    </el-dialog>
    <!-- 结束 -->
  </div>
</template>

<script>
import qs from 'qs';
export default {
  data() {
    return {
      height: window.innerHeight - 360,
      fullscreenLoading: false,
      exportSettingLoading: false,
      // 推广记录
      searchPromotionParams: {
        pageIndex: 1,
        pageSize: 10,
        tenantGuid: '',
        staffName: '',
      },
      promotionTotalRows: 0,
      promotionList: [],
      //客户明细
      showCustomer: false,
      searchCustomerParams: {
        pageIndex: 1,
        pageSize: 10,
        customerName: '',
        tenantGuid: '',
        promoteCustomerGuid: '',
      },
      customerTotalRows: 0,
      customerDetailList: [],
      tenantList: [], //所属公司下拉
      currentStaff: '',
    };
  },
  created() {
    this.getTenantData();
  },
  mounted() {},
  methods: {
    //查看客户明细
    openCustomerDialog(item) {
      this.currentStaff = item.staffName;
      this.showCustomer = true;
      this.searchCustomerParams.promoteCustomerGuid = item.guid;
      this.searchCustomerParams.tenantGuid = this.searchPromotionParams.tenantGuid;
      this.getCustomerDetailList();
    },
    //获取客户明细列表
    getCustomerDetailList() {
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/promote-customer/data/get-promote-customer-detail-list`,
          this.searchCustomerParams,
        )
        .then((resp) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            this.customerDetailList = data.records ? data.records : [];
            this.customerDetailList.sort((a, b) => {
              return new Date(b.promoteTime) - new Date(a.promoteTime);
            });
            this.customerTotalRows = data.totalRows ? data.totalRows : 0;
            this.showCustomer = true;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //清空推广记录搜索条件
    clearDialogSearch(type) {
      if (type == 1) {
        this.searchPromotionParams.pageIndex = 1;
        this.searchPromotionParams.staffName = '';
        this.getPromotionRecord();
      } else {
        this.searchCustomerParams.pageIndex = 1;
        this.searchCustomerParams.customerName = '';
        this.getCustomerDetailList();
      }
    },
    //获取推广记录
    getPromotionRecord() {
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/promote-customer/data/get-promote-customer`,
          this.searchPromotionParams,
        )
        .then((resp) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let data = resp.data.data;
            this.promotionTotalRows = data.totalRows ? data.totalRows : 0;
            this.promotionList = data.records ? data.records : [];
            this.promotionList.forEach((item) => {
              if (item.organisationNames.length) {
                let str = item.organisationNames.join('、');
                this.$set(item, 'organisationNamesText', str);
              }
            });
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },

    getTenantData() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data;
            self.searchPromotionParams.tenantGuid = self.tenantList[0].sendTenantGuid;
            setTimeout(() => {
              self.getPromotionRecord();
            }, 500);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //导出推广记录
    exportPromotion() {
      this.exportSettingLoading = true;
      this.api
        .postJson(
          `/${serverConfig.msCustomerService}/promote-customer/data/export-promote-customer`,
          this.searchPromotionParams,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
          } else {
            this.$message.error(res.data.msg);
            this.exportSettingLoading = false;
          }
        });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          self.exportSettingLoading = false;
          self.showExportHead = false;
          let blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
        });
    },
  },
};
</script> 